














































import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import {AntennaType} from '@/model/lora/AntennaType';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting} from '@/services/settings/Settings.types';
import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import {Time} from '@/utils/Time';

@Component({
  components: {},
})
export default class AntennaCheckBanner extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  private updatingAntennaType = false;

  private forceHide = true;

  private async mounted() {
    this.forceHide = this.settingsService.get(Setting.HideAntennaCheck);

    await Time.sleep(5000);

    await this.refresh();
  }

  private async refresh() {
    this.setLoading();

    try {
      await this.loraHardwareStore.fetchAntenna();
    } catch (error) {
      Notify.Error(this.logger, `Could not get antenna type`, error);
    } finally {
      this.setLoaded();
    }
  }

  private close() {
    this.settingsService.set(Setting.HideAntennaCheck, true);
    this.forceHide = true;
    this.logger.info(`Antenna type check will be hidden from now`);
  }

  private async setAntennaType(antennaType: AntennaType) {
    this.updatingAntennaType = true;
    try {
      await this.loraHardwareService.setAntennaType(antennaType.Id);
      this.loraHardwareStore.setAntenna(antennaType);
      Notify.Success(this.logger, `Thanks, your antenna is now configured`);
      this.logger.trace(`Antenna type set to' ${antennaType}'`);
    } catch (error) {
      this.logger.error(`Could not set antenna type`, error);
      Notify.Error(this.logger, `Could not set antenna type`, error);
    } finally {
      this.updatingAntennaType = false;
    }
  }
}
